import { api } from './client'

export interface EmailEngagement {
  sent: number
  opened: number
  clicked: number
  openRate: number
  clickRate: number
  from: string
  to: string
}

export async function getEmailEngagement(): Promise<EmailEngagement> {
  const { data } = await api.get<EmailEngagement>('/api/analytics/email')
  return data
}
